export default "__VITE_ASSET__BXfsptmY__"